import { useEffect } from 'react';

import { UniversesOptions } from '@/context/MenuLateral';
import { useToast } from '@/context/ToastContext';

import { useRequestSupportModal } from '@/hooks/useRequestModal';

import useUniverseMappings from '@/components/Sidebar/hooks/useUniverseMappings';

import ModalAddActivity from './components/Modal/ModalAddActivity';
import UserProfile from './components/UserInfo';
import { ActivitiesProps } from './context/FavoriteActivitiesContext';
import useActivity from './hooks/useActivity';
import IconAdd from './icons/IconAdd';
import IconProfile from './icons/IconProfile';
import IconRemove from './icons/IconRemove';
import Logo from './icons/Logo';
import HostHomeBanner from './components/HostHomeBanner';
import {
  Activities,
  Activity,
  ActivityContent,
  ActivityLink,
  Container,
  Content,
  Header,
  Text,
  Title,
  Welcome,
} from './styles';
import { useUser } from '@/context/UserContext';

const Home = () => {
  const toast = useToast();
  const { universeIconsBlueMappings } = useUniverseMappings();
  const { setIsOpenedRequestHostOpsModal } = useRequestSupportModal();
  const { userInformation } = useUser();
  const isHostUser = userInformation?.roles?.includes('Host');

  const {
    favoriteActivities,
    handleRemoveActivity,
    openModalAddActivity,
    setOpenModalAddActivity,
  } = useActivity();

  interface IActivityComponent {
    id: number;
    activity: ActivitiesProps;
  }

  interface IRenderActivity {
    activity: ActivitiesProps;
  }

  const RenderActivity = ({ activity }: IRenderActivity) => {
    if (activity.title === 'Criação de Subconta') {
      return (
        <Activity className="customStyle" onClick={() => setIsOpenedRequestHostOpsModal(true)}>
          <p>{activity.title}</p>
        </Activity>
      );
    }

    if (activity.path !== '') {
      return <ActivityLink to={activity.path}>{activity.title}</ActivityLink>;
    }

    return <Activity>{activity.title}</Activity>;
  };

  const ActivityComponent = ({ id, activity }: IActivityComponent) => (
    <ActivityContent>
      {activity.universe !== '' ? (
        universeIconsBlueMappings[activity.universe as UniversesOptions]
      ) : (
        <IconAdd
          handleAdd={() =>
            setOpenModalAddActivity({
              activityId: id,
              open: true,
            })
          }
        />
      )}

      <RenderActivity activity={activity} />

      {activity.title !== 'Adicionar Atividade' && (
        <IconRemove
          handleRemove={() => {
            handleRemoveActivity(id);
            toast.success('Atividade removida com sucesso!');
          }}
        />
      )}
    </ActivityContent>
  );

  useEffect(() => {
    document.title = 'Sapron | Home';
  }, []);

  return (
    <>
      <Header>
        <UserProfile />
        <IconProfile />
      </Header>

      <Container>
        <Content>
          <Welcome>
            <Logo />
            <Title>
              Bem-vindo <strong>Seazoner</strong>
            </Title>
          </Welcome>

          <Text>Acesse aqui as suas principais atividades</Text>

          <Activities>
            {favoriteActivities.map((activity, index) => (
              <ActivityComponent key={`${activity}-${index + 1}`} id={index} activity={activity} />
            ))}
          </Activities>
          {isHostUser && <HostHomeBanner />}
        </Content>
      </Container>
      {openModalAddActivity.open && <ModalAddActivity />}
    </>
  );
};

export default Home;
